import toast from 'react-hot-toast';
import AuthService from 'src/services/Auth.service';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import { getSession, setSessionInLocalStorage } from './sessionHandler';

let refreshPromise = null;

async function fetchAccessTokenByRefreshToken(refreshToken) {
  const tokenRes = await AuthService.refreshTokens(refreshToken);
  if (!tokenRes.success) {
    window.location.replace('/');
    return false;
  }

  const {
    access: { token: newAccessToken, expires: newAccessExpiresAt },
    refresh: { token: newRefreshToken, expires: newRefreshExpiresAt }
  } = tokenRes.data;

  setSessionInLocalStorage(
    newAccessToken,
    newRefreshToken,
    newAccessExpiresAt,
    newRefreshExpiresAt
  );

  return newAccessToken;
}

export const validateAccessToken = async () => {
  try {
    const session = getSession();
    if (!session) return false;

    const { accessToken, accessExpiresAt, refreshExpiresAt, refreshToken } =
      session;

    const now = Date.now();
    const isAccessExpired = now > new Date(accessExpiresAt).getTime();
    const isRefreshExpired = now > new Date(refreshExpiresAt).getTime();

    if (isRefreshExpired) {
      toast('Session expired! Login again.', {
        icon: <InfoRoundedIcon fontSize="small" color="info" />,
        duration: 4000
      });
      window.location.replace('/');
      return false;
    }

    if (!isAccessExpired) {
      return accessToken; // still valid
    }

    // avoid multiple parallel refresh calls
    if (!refreshPromise) {
      refreshPromise = fetchAccessTokenByRefreshToken(refreshToken);
      // clear once resolved
      refreshPromise.finally(() => {
        refreshPromise = null;
      });
    }

    return refreshPromise;
  } catch (err) {
    console.error(`Error in validating access token ${err.message}`);
    return false;
  }
};
